import { Component, Input } from '@angular/core';
import { AUTONOMOUS_LABEL, BETA_LABEL, BETA_TOOLTIP } from './beta-mark-copy';

@Component({
  selector: 'pdq-ai-mark',
  templateUrl: './ai-mark.component.html',
  styleUrls: ['./ai-mark.component.scss'],
  standalone: false,
})
export class AiMarkComponent {
  @Input() variant: 'pill' | 'inline' = 'pill';

  readonly label = AUTONOMOUS_LABEL;
  readonly status = BETA_LABEL;
  readonly tooltip = BETA_TOOLTIP;
}
